import axios from "axios";

const BASE_URL = "https://api.lensa.com.tr/api";

const axiosClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export default axiosClient;
